import { Fragment } from "react";
import PropTypes from "prop-types";

import { moneyFormater } from "../../../utilities/formaters";
import { applicationConnector } from "../../../services/applications/connector";
import ApiButton from "../../../shared/ui/Api.Button";

const CreditReport = ({
  report,
  bisnodeReport,
  application,
  createCreditsafeReport,
}) => {
  const redStyle = { backgroundColor: "#ffcccb" };

  return (
    <div>
      <div className="row">
        <div className="col-md-6">
          <h3>Credit Report</h3>
        </div>
      </div>
      {!report && application?.UserInfoFinalizedAt ? (
        <ApiButton
          sending={application.createCreditsafePending}
          error={""}
          buttonLabel={"Refetch Creditsafe report"}
          onButtonClick={() =>
            createCreditsafeReport(application.Id, application.BorrowerId)
          }
        />
      ) : (
        <Fragment />
      )}
      {report ? (
        <Fragment>
          <h4>Creditsafe report</h4>
          <table className="cs-list-table">
            <tbody>
              <tr>
                <td>Reloansys report id</td>
                <td>{report.ReportId}</td>
              </tr>
              <tr>
                <td>Timestamp</td>
                <td>{report.Created}</td>
              </tr>
              <tr>
                <td>SSN</td>
                <td>{report.Ssn}</td>
              </tr>
              <tr>
                <td>Age</td>
                <td>{report.Age}</td>
              </tr>
              <tr style={maybeRedStyle(!report.IncomeYearlyGross)}>
                <td>Yearly gross income</td>
                <td>
                  {moneyWithAsOf(
                    report.IncomeYearlyGross,
                    report.IncomeYear,
                    4,
                  )}
                </td>
              </tr>
              <tr style={maybeRedStyle(!report.IncomeYearlyGross)}>
                <td>Monthly gross income</td>
                <td>
                  {moneyWithAsOf(
                    report.IncomeYearlyGross / 12,
                    report.IncomeYear,
                    4,
                  )}
                </td>
              </tr>
              <tr style={maybeRedStyle(report.CurrentDebt)}>
                <td>Current debt (skuldsaldo)</td>
                <td>
                  {moneyWithAsOf(report.CurrentDebt, report.CurrentDebtDate, 7)}
                </td>
              </tr>
              <tr>
                <td>Address</td>
                <td>{report.Address}</td>
              </tr>
              <tr>
                <td>C/o address</td>
                <td>{report.CoAddress}</td>
              </tr>
              <tr>
                <td>Zip code</td>
                <td>{report.ZipCode}</td>
              </tr>
              <tr>
                <td>Town</td>
                <td>{report.Town}</td>
              </tr>
              {report.SpecZipCode !== null ? (
                <>
                  <tr>
                    <td>Spec Address</td>
                    <td>{report.SpecAddress}</td>
                  </tr>
                  <tr>
                    <td>Spec C/o address</td>
                    <td>{report.SpecCoAddress}</td>
                  </tr>
                  <tr>
                    <td>Spec Zip code</td>
                    <td>{report.SpecZipCode}</td>
                  </tr>
                  <tr>
                    <td>Spec Town</td>
                    <td>{report.SpecTown}</td>
                  </tr>
                </>
              ) : (
                <></>
              )}
              <tr>
                <td>#Payment remarks</td>
                <td>{report.PaymentRemarks}</td>
              </tr>
              <tr>
                <td>#Payment remarks last 12 months</td>
                <td>{report.PaymentRemarksLast12Months}</td>
              </tr>
              <tr>
                <td>#Serious remarks</td>
                <td>{report.SeriousPaymentRemarks}</td>
              </tr>
              <tr>
                <td>#Serious remarks last 12 months</td>
                <td>{report.SeriousPaymentRemarksLast12Months}</td>
              </tr>
              <tr>
                <td>#Scoring</td>
                <td>{report.Scoring}</td>
              </tr>
              {conditionalBoolRow("Missing address", report.AdddressMissing)}
              {conditionalBoolRow("Emigrated", report.Emigrated)}
              {conditionalBoolRow(
                "Protected identity",
                report.ProtectedIdentity,
              )}
            </tbody>
          </table>
        </Fragment>
      ) : (
        <Fragment />
      )}
      {bisnodeReport ? (
        <Fragment>
          <h4>Legacy Bisnode report</h4>
          <table className="cs-list-table">
            <tbody>
              <tr>
                <td>Reloansys report id</td>
                <td>{bisnodeReport.ReportId}</td>
              </tr>
              <tr>
                <td>Bisnode report id</td>
                <td>{bisnodeReport.BisnodeCorrelationId}</td>
              </tr>
              <tr>
                <td>Timestamp</td>
                <td>{bisnodeReport.Created}</td>
              </tr>
              <tr>
                <td>SSN</td>
                <td>{bisnodeReport.Ssn}</td>
              </tr>
              <tr
                style={maybeRedStyle(
                  bisnodeReport.BisnodeOutcome === "Error" ||
                    bisnodeReport.BisnodeOutcome === "No data" ||
                    bisnodeReport.BisnodeOutcome === "Unprocessable (skyddad)",
                )}
              >
                <td>Bisnode suggests</td>
                <td>{bisnodeReport.BisnodeOutcome}</td>
              </tr>
              {conditionalBoolRow("Basic reject", bisnodeReport.BasicReject)}
              <tr style={maybeRedStyle(bisnodeReport.Scoring === "0.0")}>
                <td>Scoring</td>
                <td>{bisnodeReport.Scoring}</td>
              </tr>
              <tr style={maybeRedStyle(!bisnodeReport.IncomeYearlyGross)}>
                <td>Yearly gross income</td>
                <td>
                  {moneyWithAsOf(
                    bisnodeReport.IncomeYearlyGross,
                    bisnodeReport.IncomeYear,
                    4,
                  )}
                </td>
              </tr>
              <tr style={maybeRedStyle(!bisnodeReport.IncomeYearlyGross)}>
                <td>Monthly gross income</td>
                <td>
                  {moneyWithAsOf(
                    bisnodeReport.IncomeYearlyGross / 12,
                    bisnodeReport.IncomeYear,
                    4,
                  )}
                </td>
              </tr>
              <tr style={maybeRedStyle(bisnodeReport.CurrentDebt)}>
                <td>Current debt (skuldsaldo)</td>
                <td>
                  {moneyWithAsOf(
                    bisnodeReport.CurrentDebt,
                    bisnodeReport.CurrentDebtDate,
                    7,
                  )}
                </td>
              </tr>
              {bisnodeReport.RecentNonZeroDebt ? (
                <tr style={redStyle}>
                  <td>Last debt &gt;0 (skuldsaldo)</td>
                  <td>
                    {moneyWithAsOf(
                      bisnodeReport.RecentNonZeroDebt,
                      bisnodeReport.RecentNonZeroDebtDate,
                      7,
                    )}
                  </td>
                </tr>
              ) : undefined}
              {bisnodeReport.PaymentRemarksCount ||
              bisnodeReport.PaymentRemarksAmount ? (
                <tr style={redStyle}>
                  <td>Payment Remarks</td>
                  <td>
                    {moneyWithAsOf(
                      bisnodeReport.PaymentRemarksAmount,
                      null,
                      0,
                    ) +
                      " (# " +
                      bisnodeReport.PaymentRemarksCount +
                      ")"}
                  </td>
                </tr>
              ) : undefined}
              {bisnodeReport.RecentPaymentRemarksCount ? (
                <tr style={redStyle}>
                  <td>Recent payment remarks (&lt;12 months)</td>
                  <td>{bisnodeReport.RecentPaymentRemarksCount}</td>
                </tr>
              ) : undefined}
              <tr>
                <td># Inquiries</td>
                <td>{bisnodeReport.InquiryCount}</td>
              </tr>
              <tr>
                <td>Address</td>
                <td>{bisnodeReport.Address}</td>
              </tr>
              <tr>
                <td>C/o address</td>
                <td>{bisnodeReport.CoAddress}</td>
              </tr>
              <tr>
                <td>Zip code</td>
                <td>{bisnodeReport.ZipCode}</td>
              </tr>
              <tr>
                <td>Town</td>
                <td>{bisnodeReport.Town}</td>
              </tr>
              {conditionalBoolRow("Lost id card", bisnodeReport.IdDocumentLost)}
              {conditionalBoolRow(
                "Box addr big city",
                bisnodeReport.BoxAddressMajorCity,
              )}
              {conditionalBoolRow("Missing addr", bisnodeReport.AddressMissing)}
              {conditionalBoolRow(
                "Poste restante",
                bisnodeReport.PosteRestanteAddress,
              )}
              {conditionalBoolRow("Age below 18", bisnodeReport.AgeBelow18)}
              {conditionalBoolRow("Emigrated", bisnodeReport.Emigrated)}
              {conditionalBoolRow(
                "Immigrated <6 months",
                bisnodeReport.ImmigratedRecently,
              )}
              {conditionalBoolRow("Has guardian", bisnodeReport.Guardianship)}
              {conditionalBoolRow(
                "Coordination number",
                bisnodeReport.CoordinationNumber,
              )}
              {conditionalBoolRow(
                "Protected identity",
                bisnodeReport.ProtectedIdentity,
              )}
              {conditionalBoolRow(
                "Debt settl. (skuldsan.)",
                bisnodeReport.DebtSettlement,
              )}
              {conditionalBoolRow(
                "Distraint (utmätn.)",
                bisnodeReport.Distraint,
              )}
              {conditionalBoolRow(
                "Too many payment remarks (says bisnode)",
                bisnodeReport.TooManyPaymentRemarks,
              )}
            </tbody>
          </table>
        </Fragment>
      ) : undefined}
    </div>
  );

  function maybeRedStyle(cond) {
    return cond ? redStyle : {};
  }

  function conditionalBoolRow(label, value) {
    let str = "not set";
    if (value === true) str = "Yes";
    if (value === false) str = "No";
    return value ? (
      <tr style={redStyle}>
        <td>{label}</td>
        <td>{str}</td>
      </tr>
    ) : (
      <Fragment />
    );
  }

  function moneyWithAsOf(value, asOf, asOfLength) {
    let text = value || value === 0 ? moneyFormater(value, 0) + " kr" : "?";
    if (asOf)
      text =
        text +
        " (as of " +
        asOf.substring(0, Math.min(asOf.length, asOfLength)) +
        ")";
    return text;
  }
};

CreditReport.propTypes = {
  report: PropTypes.object,
  bisnodeReport: PropTypes.object,
  application: PropTypes.object,
  createCreditsafeReport: PropTypes.func,
};

export default applicationConnector(CreditReport);
